import { render, staticRenderFns } from "./MetricGlossary.vue?vue&type=template&id=f3cd6efa"
import script from "./MetricGlossary.vue?vue&type=script&lang=js"
export * from "./MetricGlossary.vue?vue&type=script&lang=js"
import style0 from "./MetricGlossary.vue?vue&type=style&index=0&id=f3cd6efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports